import type { MaybeRefOrGetter } from 'vue';
import type { GlobalFieldId } from '#layers/data-model';
import type { ResolvedMonospaceSingleRelationField } from '#layers/data-model/types/schema/resolved-schema';
import { computed, toValue } from 'vue';
import { getRelationPrimitiveFields } from '#layers/data-model';
import { usePermissionsStore } from '~/stores/permissions';

export interface UseRelationPermissionsOptions {
	field: MaybeRefOrGetter<ResolvedMonospaceSingleRelationField | null>;
	isCreateForm: MaybeRefOrGetter<boolean>;
}

export function useRelationPermissionsBase(options: UseRelationPermissionsOptions) {
	const permissionsStore = usePermissionsStore();

	const field = computed(() => toValue(options.field));
	const currentColId = computed(() => field.value?.collection?.id ?? null);
	const oppositeColId = computed(() => field.value?.oppositeCollection?.id ?? null);
	const isCreateForm = computed(() => toValue(options.isCreateForm));

	// Get constrained field IDs using utility
	const constraintFields = computed(() => {
		if (!field.value) return { fields: [], oppositeFields: [] };
		return getRelationPrimitiveFields(field.value);
	});

	const localConstrainedFieldIds = computed<GlobalFieldId[]>(
		() => constraintFields.value.fields.map((f) => f.id),
	);

	const oppositeConstrainedFieldIds = computed<GlobalFieldId[]>(
		() => constraintFields.value.oppositeFields.map((f) => f.id),
	);

	return {
		permissionsStore,
		field,
		currentColId,
		oppositeColId,
		isCreateForm,
		localConstrainedFieldIds,
		oppositeConstrainedFieldIds,
	};
}
